import { BigNumber } from '@0x/utils'
import './styles/index.scss'
import appConfig from 'bzx-common/src/config/appConfig'
import RootStore from 'bzx-common/src/stores/RootStore'
import { Provider } from 'mobx-react'
import React from 'react'
import ReactDOM from 'react-dom'
import ReactModal from 'react-modal'
import App from './components/App'
import services from './services'

// @see https://webpack.js.org/guides/dependency-management/#context-module-api
function importAll(contextModule: any) {
  contextModule.keys().forEach(contextModule)
}

// @ts-ignore
importAll(require.context('../../bzx-common/src/assets/svg-sprite', true, /.svg$/))

services.start()
const rootStore = new RootStore({ services })
rootStore.init()

ReactModal.setAppElement('#root')

const theme = localStorage.getItem('theme') || 'dark'
document.documentElement.setAttribute('data-theme', theme)
localStorage.setItem('theme', theme)

if (process.env.NODE_ENV === 'development' || localStorage.getItem('devExposeStore')) {
  // Expose the rootStore to window for easy debug in dev
  // @ts-ignore
  window.rootStore = rootStore
  // @ts-ignore
  window.appConfig = appConfig
  // @ts-ignore
  window.BigNumber = BigNumber

  global.llog = function llog() {
    // eslint-disable-next-line prefer-rest-params
    Array.from(arguments).forEach((val) => {
      console.log(JSON.stringify(val, null, 2))
    })
  }
}

ReactDOM.render(
  <Provider rootStore={rootStore}>
    <App rootStore={rootStore} />
  </Provider>,
  document.getElementById('root')
)
